import React from 'react';
import PT from 'prop-types';
import { Tabs } from '@procore/core-react';

const TabList = ({ tabs, active, onClick }) => (
  <Tabs className="tabs tabs--full">
    {tabs.map(({ key, value, condition }) =>
      condition ? (
        <Tabs.Tab
          key={key}
          data-qa={`admin-${key.toLowerCase()}-tab`}
          data-testid={`admin-${key.toLowerCase()}-tab`}
          variant={active === value ? 'active' : ''}
        >
          <Tabs.Link onClick={() => onClick(value)}>{value}</Tabs.Link>
        </Tabs.Tab>
      ) : null
    )}
  </Tabs>
);

TabList.propTypes = {
  tabs: PT.arrayOf(
    PT.shape({
      key: PT.string.isRequired,
      value: PT.string.isRequired,
      condition: PT.bool,
    })
  ).isRequired,
  active: PT.string.isRequired,
  onClick: PT.func.isRequired,
};

export default TabList;
